import { Flex, Stack } from "@mantine/core";
import style from "./about-us.module.css";
import { useTranslation } from "react-i18next";

import OsloImage from "./../../../../assets/oslo.webp";
import FounderImage from "./../../../../assets/FounderImage.webp";

export const AboutUsPage = () => {
    const { t, i18n } = useTranslation("landing-page");
    
    // Get the appropriate brand name based on current language
    const getBrandName = () => {
        switch (i18n.language) {
            case 'en':
                return 'Gradr.ai';
            case 'se':
                return 'Verklig.ai';
            case 'dk':
                return 'Virkelig.ai';
            case 'nl':
                return 'Werkelijk AI';
            case 'de':
            case 'fr':
            case 'es':
                return 'AI Detectors';
            default:
                return 'Ekte.ai';
        }
    };
    
    const brandName = getBrandName();

    return (
        <div className={style.wrapper}>
            <div className={style.innerWrapper}>
                <div className={style.contentWrapper}>
                    <Stack spacing={"0.5rem"} mt={"8rem"} className={style.textContent}>
                        <h2 className={style.header}>{t("about_us.title")}</h2>

                        <p className={style.text}>
                            {t("about_us.intro", { brand: brandName })}
                        </p>

                        <p className={style.text}>
                            {t("about_us.vision")}
                        </p>

                        <p className={style.text}>
                            {t("about_us.growth", { brand: brandName })}
                        </p>

                        <p className={style.text}>{t("about_us.core_values")}</p>

                        <p className={style.text}>
                            {t("about_us.integrity")}
                        </p>

                        <p className={style.text}>
                            {t("about_us.future", { brand: brandName })}
                        </p>

                        <Flex mt={"4rem"} columnGap={"2rem"} align={"center"}>
                            <img className={style.founderImage} src={FounderImage} alt={t("about_us.founder_image_alt")}></img>
                            
                            <Stack spacing={"0.25rem"}>
                                <p>{t("about_us.founder_name")}</p>

                                <p className={style.founderTitle}>{t("about_us.founder_title")}</p>
                            </Stack>
                        </Flex>
                    </Stack>

                    <div className={style.imageWrapper}>
                        <img className={style.image} src={OsloImage} alt={t("about_us.company_image_alt", { brand: brandName })}></img>
                    </div>
                </div>
            </div>
        </div>
    );
};
